import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Entete, PiedDePage } from './composants.js';
import { Accueil, PageActualite, PageActualites, PageArtiste, PageArtistes, PageContact, PageExposition, PageExpositions, PageFoires, PageIntrouvable, PageLaGalerie, PageOeuvre, PageOeuvres, PagePlanDuSite, PageTexteSimple, } from './pages.js';
function contenu(ctx) {
    switch (ctx.vue.type) {
        case 'accueil':
            return _jsx(Accueil, { ctx: ctx });
        case 'artistes':
            return _jsx(PageArtistes, { ctx: ctx });
        case 'artiste': {
            const artiste = ctx.artiste(ctx.vue.slug);
            return artiste === undefined ? (_jsx(PageIntrouvable, { ctx: ctx })) : (_jsx(PageArtiste, { ctx: ctx, artiste: artiste }));
        }
        case 'expositions':
            return _jsx(PageExpositions, { ctx: ctx });
        case 'foires':
            return _jsx(PageFoires, { ctx: ctx });
        case 'exposition':
        case 'foire': {
            const exposition = ctx.exposition(ctx.vue.slug);
            return exposition === undefined ? (_jsx(PageIntrouvable, { ctx: ctx })) : (_jsx(PageExposition, { ctx: ctx, exposition: exposition }));
        }
        case 'oeuvres':
            return _jsx(PageOeuvres, { ctx: ctx });
        case 'oeuvre': {
            const oeuvre = ctx.oeuvre(ctx.vue.slug);
            return oeuvre === undefined ? (_jsx(PageIntrouvable, { ctx: ctx })) : (_jsx(PageOeuvre, { ctx: ctx, oeuvre: oeuvre }));
        }
        case 'actualites':
            return _jsx(PageActualites, { ctx: ctx });
        case 'actualite': {
            const actualite = ctx.actualite(ctx.vue.slug);
            return actualite === undefined ? (_jsx(PageIntrouvable, { ctx: ctx })) : (_jsx(PageActualite, { ctx: ctx, actualite: actualite }));
        }
        case 'la-galerie':
            return _jsx(PageLaGalerie, { ctx: ctx });
        case 'contact':
            return _jsx(PageContact, { ctx: ctx });
        case 'mentions':
            return _jsx(PageTexteSimple, { ctx: ctx, page: ctx.siteData.pages.mentions });
        case 'confidentialite':
            return _jsx(PageTexteSimple, { ctx: ctx, page: ctx.siteData.pages.confidentialite });
        case 'plan-du-site':
            return _jsx(PagePlanDuSite, { ctx: ctx });
        case 'introuvable':
            return _jsx(PageIntrouvable, { ctx: ctx });
    }
}
/**
 * Contenu de `<body>` pour le thème **Accrochage** : l'image d'abord, sans
 * `.wrap` global — en-tête, pied et texte se resserrent dans une boîte
 * lisible, mais les grilles d'œuvres et les visuels courent bord à bord.
 * Aucune icône (2.5).
 */
export function Corps({ ctx }) {
    return (_jsxs(_Fragment, { children: [_jsx("a", { className: "saut", href: "#contenu", children: ctx.l.allerAuContenu }), _jsx(Entete, { ctx: ctx }), _jsx("main", { id: "contenu", children: contenu(ctx) }), _jsx(PiedDePage, { ctx: ctx })] }));
}
//# sourceMappingURL=Corps.js.map